<template>
  <section class="block portal client-portal login">
    <div class="portal__wrapper">
      <form class="portal__content form" @submit.prevent="sendrequest" autocomplete="on">
        <h1 class="portal__title title--xl">{{ formtitle }}</h1>
        <div v-if="expiredRequest" class="text--emphasis">{{ getUiString(['request_new_password', 'request_expired_text']) }}</div>
        <div v-if="requestsent" class="text--emphasis">{{ getUiString(['request_new_password', 'request_sent_text']) }}</div>
        <div v-if="!requestsent" class="form__row" @input="error = false">
          <lennoc-input
            id="email"
            type="email"
            :validators="emailValidators"
            :label="getUiString(['request_new_password', 'email'])"
            v-model="email"
            :domClass="getErrorClass"
          ></lennoc-input>
          <div class="error" v-if="error">{{ getErrorMessage }}</div>
        </div>
        <div v-if="!requestsent" class="group">
          <button
            class="button button--prim"
            :disabled="isDisabled"
          >{{ getUiString(['request_new_password', 'button']) }}</button>
          <a class="link link--login" href="#" @click.prevent="login">{{ getUiString(['request_new_password', 'back']) }}</a>
        </div>
      </form>
    </div>
    <lennoc-spinner v-if="busy" />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { email } from '@/validators/index'

export default {
  name: 'RequestPasswordChange',
  data () {
    return {
      busy: false,
      error: 0,
      email: '',
      requestsent: false,
      expiredRequest: false
    }
  },
  beforeMount () {
    if (this.$route.params.expired === 'expired') {
      this.expiredRequest = true
    }
  },
  methods: {
    sendrequest () {
      this.busy = true
      const { email } = this
      this.$store.dispatch('account/requestPasswordChange', { email })
        .then(() => {
          this.requestsent = true
          this.expiredRequest = false
        })
        .finally(() => { this.busy = false })
    },
    login () {
      this.$router.push('/')
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString'
    }),
    formtitle () {
      return this.requestsent
        ? this.getUiString(['request_new_password', 'request_sent_title'])
        : (this.expiredRequest
          ? this.getUiString(['request_new_password', 'request_expired_title'])
          : this.getUiString(['request_new_password', 'title']))
    },
    emailValidators () {
      const vld = email
      email.message = this.getUiString(['request_new_password', 'invalid_email'])
      return [vld]
    },
    isDisabled () {
      return this.busy || !email.validate(this.email)
    },
    getErrorClass () {
      return this.error > 0 ? 'form__group--error' : ''
    }
  }
}
</script>
